// import LoadingSpinner from 'apps/ringle-student/components/common/LoadingSpinner'
// import ViewMoreButton from 'apps/ringle-student/components/new-portal/caf/common/ViewMoreButton'
// import HighlightDetailListAI from 'apps/ringle-student/components/new-portal/caf/highlight/HighlightDetailListAI'
// import HighlightDetailListCorrection from 'apps/ringle-student/components/new-portal/caf/highlight/HighlightDetailListCorrection'
// import HighlightDetailListGeneral from 'apps/ringle-student/components/new-portal/caf/highlight/HighlightDetailListGeneral'
// import HighlightIntro from 'apps/ringle-student/components/new-portal/caf/highlight/HighlightIntro'
// import RingleTip from 'apps/ringle-student/components/new-portal/caf/highlight/RingleTip'
// import { HIGHLIGHT_TAG_MAP, HighlightDetailResponse } from 'apps/ringle-student/model/caf.interface'
// import { app_api_result_postmsg } from 'apps/ringle-student/modules/consts/caf'
// import { HEADER_NAV_TAG_WORDING } from 'apps/ringle-student/modules/hooks/webview/caf/chart/utilFunction'
// import useRNMsg from 'apps/ringle-student/modules/hooks/webview/common/useRNMsg'

import { useToast } from '@repo/design-system/index'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { HIGHLIGHT_TAG_MAP, HighlightDetailResponse } from '../../../../../model/caf.interface'
import { useCafHighlightV5, useCafPinnedV5 } from '../../../../../modules/apis/webview/caf'
import { app_api_result_postmsg } from '../../../../../modules/consts/caf'
import useIsWebview from '../../../../../modules/hooks/common/useIsWebview'
import { HEADER_NAV_TAG_WORDING } from '../../../../../modules/hooks/webview/caf/chart/utilFunction'
import useRNMsg from '../../../../../modules/hooks/webview/common/useRNMsg'
import { n_caf } from '../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { IC_CAF_PIN_INACTIVE, IC_PIN_PRIMARY_HIGHLIGHT } from '../../../../../modules/images'
import { useConversationAIStack } from '../../../../../pages/[lang]/webview/conversational-ai'
import LoadingSpinner from '../../../../common/LoadingSpinner'
import ViewMoreButton from '../../../../new-portal/caf/common/ViewMoreButton'
import HighlightDetailListAI from '../../../../new-portal/caf/highlight/HighlightDetailListAI'
import HighlightDetailListCorrection from '../../../../new-portal/caf/highlight/HighlightDetailListCorrection'
import HighlightDetailListGeneral from '../../../../new-portal/caf/highlight/HighlightDetailListGeneral'
import HighlightDetailListPronunciation from '../../../../new-portal/caf/highlight/HighlightDetailListPronunciation'
import HighlightIntro from '../../../../new-portal/caf/highlight/HighlightIntro'
import RingleTip from '../../../../new-portal/caf/highlight/RingleTip'
import WebviewStackContainer from '../../../common/WebviewStackContainer'

const AIHighlightDetailActivity = ({ params }) => {
  const { useConversationAIFlow } = useConversationAIStack()
  const { pop } = useConversationAIFlow()
  const { highlightId, tag } = params
  const { t } = useTranslation()

  const {
    data: response,
    error,
    refetch,
    isLoading,
    fetchNextPage,
    isFetchingNextPage,
  } = useCafHighlightV5(+highlightId)
  const { mutate } = useCafPinnedV5()
  const { toastSuccess } = useToast()
  const isWebview = useIsWebview()
  const [data, setData] = useState<HighlightDetailResponse>(null)

  useEffect(() => {
    setData({
      ...response?.pages[0],
      details:
        response?.pages?.reduce((ac, cr) => {
          return [...ac, ...cr.details]
        }, []) || [],
    })
  }, [response])

  const toastSuccessMsg = t(n_caf.accuracy.error_toast)
  const { receivePostMsg, removeListener } = useRNMsg()
  useEffect(() => {
    const handlePostmsgData = (postMsgData) => {
      if (postMsgData === app_api_result_postmsg.report.success) {
        toast(toastSuccessMsg)
      }
      if (postMsgData === app_api_result_postmsg.report.fail) {
        toast('Try again.')
      }
    }
    receivePostMsg((message) => handlePostmsgData(message))
    return () => {
      removeListener(handlePostmsgData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toastSuccessMsg])

  const pinHighlight = () => {
    mutate(
      { tag: data?.highlight_tag, active: !data?.is_pinned },
      {
        onSuccess: () => {
          if (!data?.is_pinned) {
            isWebview ? toastSuccess(t(n_caf.highlight_list_edit.toast1)) : toast(t(n_caf.highlight_list_edit.toast1))
          } else {
            isWebview ? toastSuccess(t(n_caf.highlight_list_edit.toast2)) : toast(t(n_caf.highlight_list_edit.toast2))
          }
        },
        onSettled: () => {
          refetch()
        },
      }
    )
  }

  return (
    <div>
      <WebviewStackContainer
        height="52px"
        onBack={pop}
        appendRight={() => (
          <Image
            src={data?.is_pinned ? IC_PIN_PRIMARY_HIGHLIGHT : IC_CAF_PIN_INACTIVE}
            width={31}
            height={31}
            alt="pin"
            className="fixed right-[17px] z-[9999]"
            onClick={pinHighlight}
          />
        )}
        title={t(HEADER_NAV_TAG_WORDING[+tag])}
        border={true}
      >
        {isLoading || !data ? (
          <div className="h-screen">
            <LoadingSpinner lg primary show />
          </div>
        ) : (
          <div className="bg-gray-50">
            <div className="keep-all min-h-screen break-words px-[20px] pt-[16px] pb-[16px] text-gray-700">
              <HighlightIntro data={data} />
              <RingleTip tag={tag} />
              {+tag === HIGHLIGHT_TAG_MAP.ros ||
              +tag === HIGHLIGHT_TAG_MAP.repetition ||
              +tag === HIGHLIGHT_TAG_MAP.sentence_structure ? (
                <HighlightDetailListAI details={data.details} tag={tag} />
              ) : +tag === HIGHLIGHT_TAG_MAP.pronunciation ? (
                <HighlightDetailListPronunciation details={data.details} highlightId={highlightId} tag={tag} />
              ) : +tag <= 12 ? (
                // 문법
                <HighlightDetailListCorrection details={data.details} tag={tag} />
              ) : (
                // 그 외
                <HighlightDetailListGeneral details={data.details} page={data.page} />
              )}
            </div>
            {response && !!response?.pages[response?.pages.length - 1]?.page?.next && (
              <div className="flex justify-center pb-[88px]">
                <ViewMoreButton handleClick={fetchNextPage} isFetchingNextPage={isFetchingNextPage} />
              </div>
            )}
          </div>
        )}
      </WebviewStackContainer>
    </div>
  )
}

export default AIHighlightDetailActivity
